module.exports = __webpack_public_path__ + "static/media/main-hatching-waiting.869c7001.png";